import React, { Fragment } from 'react';
import styled from 'styled-components';
import PromoHeader from 'components/common/promoHeader/PromoHeader';
import HotelsList from './components/hotelsList/HotelsList';
import DefaultTemplate from '../default/DefaultTemplate';
import DestinationsListSection from '../country/components/DestinationsListSection/DestinationsListSection';
import { mediaQueries } from 'styles/utils/mediaQueries';

function NorwegianLandingpageTemplateComponent({ image, description, destinations, hotels }) {
  return (
    <Fragment>
      <PromoHeader image={image} imageOverlay={false} />
      <DefaultTemplate content={{ description }} />
      {destinations.length > 0 && (
        <DestinationsListSectionWrap>
          <DestinationsListSection destinations={destinations} hideTitle />
        </DestinationsListSectionWrap>
      )}
      {hotels.length > 0 && <HotelsList hotels={hotels} />}
    </Fragment>
  );
}

export default NorwegianLandingpageTemplateComponent;

const DestinationsListSectionWrap = styled.div`
  width: 1024px;
  margin: 0 auto 25px;
  padding: 0 15px;

  ${mediaQueries.fromAndBelow.desktop`
    width: 750px;
  `}

  ${mediaQueries.fromAndBelow.tablet`
    width: 100%
  `}
`;
